import { render, staticRenderFns } from "./strong-confirmation-popup.vue?vue&type=template&id=c05a6996&"
import script from "./strong-confirmation-popup.vue?vue&type=script&lang=js&"
export * from "./strong-confirmation-popup.vue?vue&type=script&lang=js&"
import style0 from "./strong-confirmation-popup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports